import { getBackgroundImage } from "../../helpers";
import { buildSoccerLiveMobileProps } from "../buildSoccerLiveMobileProps";
export const buildSoccerLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildSoccerLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildSoccerLiveDesktopProps.js.map